import React from 'react';
import { LabelTypePreview } from './label-type-preview';

export const labelTypesOptions = (['LABEL_TYPE_CUSTOM', 'LABEL_TYPE_SWAN'] as const).map(value => ({
  value,
  label: <LabelTypePreview type={value} />,
}));
